export default __webpack_public_path__ + "static/media/bg5.1bc8295b.jpg";